<template>
  <v-card class="mb-12 mx-auto" flat>
    <v-card-title
      class="justify-center font-weight-black text-uppercase"
      style="color: #01579B !important;"
    >
      Add new {{ eventType }}
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md>
        <v-form ref="calendarForm" v-model="isFormValid">
          <v-layout wrap justify-center>
            <v-flex xs12>
              <h3 class="delimiter_text">General info</h3>
            </v-flex>
            <v-flex xs12 sm8 md6>
              <v-text-field
                v-model.trim="event.summary"
                outlined
                color="light-blue darken-4"
                hide-details
                :rules="requiredRule"
                dense
                :label="`${eventType} name`"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm8 md6>
              <v-text-field
                v-model="event.description"
                outlined
                color="light-blue darken-4"
                hide-details
                :rules="requiredRule"
                dense
                :label="`${eventType} description`"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <h3 class="delimiter_text">Time details</h3>
            </v-flex>
            <v-flex xs12 sm6>
              <v-menu
                ref="menu"
                v-model="timeStartMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="timeStart"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    color="light-blue darken-4"
                    dense
                    v-model="timeStart"
                    :rules="requiredRule"
                    label="Start event time"
                    prepend-inner-icon="fa-clock"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="timeStartMenu"
                  color="light-blue darken-4"
                  v-model="timeStart"
                  full-width
                  @click:minute="$refs.menu.save(timeStart)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm6>
              <v-menu
                ref="menu1"
                v-model="timeEndMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="timeEnd"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    dense
                    :rules="requiredRule"
                    color="light-blue darken-4"
                    v-model="timeEnd"
                    label="End event time"
                    prepend-inner-icon="fa-clock"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="timeEndMenu"
                  color="light-blue darken-4"
                  v-model="timeEnd"
                  full-width
                  @click:minute="$refs.menu1.save(timeEnd)"
                ></v-time-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12>
              <h3 class="delimiter_text">Members section</h3>
            </v-flex>
            <v-layout align-center justify-space-between>
              <v-flex xs10>
                <v-text-field
                  color="light-blue darken-4"
                  v-model="newMemberEmail"
                  outlined
                  :rules="emailRule"
                  prepend-inner-icon="fa-at"
                  hide-details
                  dense
                  label="Add event member"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-btn
                  outlined
                  block
                  @click="addNewMember"
                  color="light-blue darken-4"
                  dark
                  >Add</v-btn
                >
              </v-flex>
            </v-layout>
            <v-flex xs12 v-if="event.attendees.length > 0">
              <v-list nav dense>
                <v-list-item-title>Members list</v-list-item-title>
                <v-list-item-group>
                  <v-list-item v-for="(item, i) in event.attendees" :key="i">
                    <v-list-item-icon>
                      <v-icon>fa-user</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title
                        v-text="item.email"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-flex>
            <v-flex xs12 v-else class="mt-3">
              <v-alert
                color="light-blue darken-4"
                dark
                icon="fa-users"
                border="left"
                prominent
              >
                Currently you have no members for current event
              </v-alert>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="light-blue darken-4" dark text @click="close">Cancel</v-btn>
      <v-btn color="light-blue darken-4" dark text @click="addNewEvent"
        >Add</v-btn
      >
    </v-card-actions>
  </v-card>
</template>
<script>
/* eslint-disable prettier/prettier */
import { validation } from "@/mixins/validationMixin";
import { validationRules } from "@/constants/global";

export default {
  mixins: [validation],
  props: {
    eventType: {
      type: String,
      required: true
    },
    eventDateInfo: {
      type: [Object, Boolean],
      required: true
    }
  },
  data() {
    return {
      isFormValid: true,
      newMemberEmail: "",
      timeStart: "",
      timeEnd: "",
      timeStartMenu: false,
      timeEndMenu: false,
      emailRule: validationRules.email,
      event: {
        summary: "",
        location: "",
        description: "",
        start: {
          dateTime: "",
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
        end: {
          dateTime: "",
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
        recurrence: [],
        attendees: [],
        reminders: {
          useDefault: false
        }
      },
      defaultEventData: {
        summary: "",
        location: "",
        description: "",
        start: {
          date: "",
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
        end: {
          date: "",
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
        recurrence: [],
        attendees: [],
        reminders: {
          useDefault: false
        }
      }
    }
  },
  methods: {
    close() {
      this.event = Object.assign({}, this.defaultEventData);
      this.timeStart = "";
      this.timeEnd = "";
      this.newMemberEmail = "";
      this.timeStartMenu = false;
      this.timeEndMenu = false;
      this.$emit("close-form");
    },
    addNewEvent() {
      let newEndDate = this.eventDateInfo.date.split("-");
      newEndDate[2] = String(+newEndDate[2] + 1);
      // ! Problem here
      this.event.start.date = `${this.eventDateInfo.date}`;
      this.event.end.date = `${newEndDate.join("-")}`;
      if (window.gapi) {
        let request = window.gapi.client.calendar.events.insert({
          'calendarId': 'primary',
          'resource': this.event 
        });

        request.execute(event => {
          console.log(event);
        });
      }
      console.log(this.event);
      console.log(this.eventDateInfo);
    },
    addNewMember() {
      const hasMember = this.event.attendees.filter(
        el => el.email === this.newMemberEmail
      );

      if (hasMember.length > 0) {
        this.$toast.error("Member with current email already exist.");
      } else {
        this.event.attendees.push({ email: this.newMemberEmail });
      }

      this.newMemberEmail = "";
    }
  }
};
</script>
<style lang=""></style>
